import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { CustomerService } from '../../customer-billing-customer/customer.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { CustomerBillingCustomerModel } from '../../customer-billing-customer/customer-billing-customer.model';
import { CustomerBillingOtherCustomerModel } from '../../customer-billing-other-customer/customer-billing-other-customer.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-customer-billing-customer-unit-edit',
    templateUrl: './customer-billing-customer-unit-edit.component.html',
    styleUrls: ['./customer-billing-customer-unit-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-unit-edit' },
    standalone: false,
})
export class CustomerBillingCustomerUnitEditComponent implements OnInit {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() resellers: CustomerBillingOtherCustomerModel[];

    EditTabs: EditTabsModel;

    // note: not used for now
    // ContractLengthListData: DropdownSettingsModel;

    constructor(
        private appTextService: AppTextService,
        private customerService: CustomerService,
        private fiLoadingService: LoadingService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
    ) {}

    ngOnInit() {
        this.setListsData();
        this.setPageHeaderData();
    }

    private setListsData() {
        // note: not used for now
        // this.ContractLengthListData = new DropdownSettingsModel();
        // fiTerminationPeriodTypes.forEach((type: ITerminationPeriod) => {
        //     this.ContractLengthListData.DataSet.push({
        //         Id: type.Id,
        //         Name: this.appTextService.get(type.TextId)
        //     });
        // });
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(
            this.objectTitleService.getEditTitle(this.customer.Name || this.customer.BusinessUnitName),
        );
        this.EditTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    getResellerName(): string {
        const item: CustomerBillingOtherCustomerModel = this.resellers.find(
            (item) => item.Id === this.customer.ResellerId,
        );
        if (item) return item.Name;
    }

    save() {
        this.fiLoadingService.trackPromise(this.customerService.SaveCustomerUnit(this.customer)).then(() => {
            this.stateService.go(FiStateNames.CustomerBilling.CustomerUnits.List);
        });
    }
}
